export default function PageHeader({ eyebrow, title, description, actions, testId }) {
  return (
    <header className="mb-8 flex flex-col sm:flex-row sm:items-start justify-between gap-4 sm:gap-6" data-testid={testId}>
      <div>
        {eyebrow && <div className="overline mb-3">{eyebrow}</div>}
        <h1 className="font-display font-black text-4xl sm:text-5xl leading-[1.05] tracking-tight text-[var(--text)]">
          {title}
        </h1>
        {description && (
          <p className="mt-3 text-sm text-[var(--text-muted)] max-w-2xl leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 sm:shrink-0">{actions}</div>}
    </header>
  );
}
